import styled from 'styled-components';
import {
    sectionPadding,
    sectionPaddingNoBottom,
    sectionPaddingNoTop,
    sectionPaddingNoSides,
    sectionPaddingOnlySides,
} from './mixins';

export const DefaultSection = styled.section``;
export const DefaultSectionNoBottom = styled.section`
    ${sectionPaddingNoBottom}
`;
export const DefaultSectionNoTop = styled.section`
    ${sectionPaddingNoTop}
`;

export const DefaultSectionNoSides = styled.section`
    ${sectionPaddingNoSides}
`;
export const DefaultSectionOnlySides = styled.section`
    ${sectionPaddingOnlySides}
`;
